import type { Building } from "building-types/building/buildingTypes";
import type { Parameter, ParameterValue } from "building-types/options/parameter";
import type { Table } from "common/data/table";
import { getBuildingParameterValues } from "../getBuildingParameterValues";
import { evaluateParameterDefaultValues } from "../parameterCoreTools";
import { BuildingParameters } from "../systemParameters";

export interface AnnotationParameterContext {
  readonly paramValues: Table<ParameterValue>;
  readonly params: typeof BuildingParameters & Table<Parameter>;
}

export function resolveAnnotationParameterContext(
  building: Building,
  globalParameterValues: Table<ParameterValue> = {},
): AnnotationParameterContext {
  const buildingParamValues = getBuildingParameterValues(building);
  const globalParamDefaultValues = evaluateParameterDefaultValues(building.doc.globalParameters);
  return {
    paramValues: {
      ...buildingParamValues,
      ...globalParamDefaultValues,
      ...globalParameterValues,
    },
    params: {
      ...BuildingParameters,
      ...building.doc.globalParameters,
    },
  };
}
